import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { config as zodConfig } from 'zod/v4/core'
import { Providers } from '@/app/providers'
import { router } from '@/app/router'
import { captureGoogleSignUp } from '@/lib/analytics'
import { captureReferralFromUrl } from '@/lib/referral'
import { initSentry, rootErrorOptions } from '@/lib/sentry'
import '@/styles/index.css'

// Zod checks whether it may compile validators with new Function(); the Content-Security-Policy
// doesn't allow that (no 'unsafe-eval'), so it skips the check and validates without it.
zodConfig({ jitless: true })
initSentry()
// A partner's link straight to the app (?ref=CODE): kept with consent to partner referrals.
captureReferralFromUrl()
// A new account from Google sign-in: counted as a sign-up for Google Analytics (with consent).
captureGoogleSignUp()

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

createRoot(root, rootErrorOptions).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
